import { AfterViewInit, Component, ElementRef, Inject, OnDestroy, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogClose } from '@angular/material/dialog';
import * as echarts from 'echarts';

export interface ChartFullscreenDialogData {
  title: string;
  option: any;
}

@Component({
  selector: 'app-chart-fullscreen-dialog',
  templateUrl: './chart-fullscreen-dialog.component.html',
  styleUrls: ['./chart-fullscreen-dialog.component.scss'],
  imports: [MatDialogClose],
})
export class ChartFullscreenDialogComponent implements AfterViewInit, OnDestroy {
  @ViewChild('chartContainer', { static: true }) chartContainer!: ElementRef<HTMLDivElement>;

  private chartInstance?: echarts.ECharts;
  private resizeObserver?: ResizeObserver;

  constructor(@Inject(MAT_DIALOG_DATA) public data: ChartFullscreenDialogData) {}

  ngAfterViewInit(): void {
    const chartDom = this.chartContainer.nativeElement;
    this.chartInstance = echarts.init(chartDom, null, { renderer: 'svg' });
    this.chartInstance.setOption(this.data.option, true);

    this.resizeObserver = new ResizeObserver(() => this.chartInstance?.resize());
    this.resizeObserver.observe(chartDom);
  }

  ngOnDestroy(): void {
    this.resizeObserver?.disconnect();
    this.chartInstance?.dispose();
  }
}
